import { type CoachingSessionType } from '@efdigital/ll-addon-data';
import { selectValue } from '@efdigital/ll-addon-ui';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

interface SelectSessionTypeSignature {
  Args: {
    value: CoachingSessionType | '';
    onChange: (value: CoachingSessionType) => void;
  };
  Element: HTMLSelectElement;
}

const SESSION_TYPES: Record<CoachingSessionType, string> = {
  chemistry: 'Chemistry',
  coaching: 'Coaching',
};

const ALL_SESSION_TYPES = Object.entries(SESSION_TYPES).map(
  ([type, label]) => ({ type, label })
);

export class SelectSessionType extends Component<SelectSessionTypeSignature> {
  onChange = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    this.args.onChange(target.value as CoachingSessionType);
  };

  <template>
    <select
      class="form-select"
      ...attributes
      {{selectValue @value}}
      {{on "change" this.onChange}}
    >
      <option value="">All</option>
      {{#each ALL_SESSION_TYPES as |item|}}
        <option value={{item.type}}>{{item.label}}</option>
      {{/each}}
    </select>
  </template>
}
